import { useTranslation } from '@/ui/hooks';
import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';

export const HomePage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 4 }}>
            <Typography variant='h4' component='h1'>
                {t('appTitle')}
            </Typography>
            <ul>
                <li>
                    <Link component={NavLink} to='downloads'>
                        {t('downloads')}
                    </Link>
                </li>
                <li>
                    <Link component={NavLink} to='users'>
                        {t('users')}
                    </Link>
                </li>
            </ul>
        </Box>
    );
};
